import { SITE } from "@/data/site";

export const czk = (n) => `${Number(n).toLocaleString("cs-CZ").replace(/\u00a0/g, " ")} Kč`;

export const addonPrice = (key) => SITE.addons.find((a) => a.key === key)?.price || 0;
export const getBundle = (key) => SITE.bundles.find((b) => b.key === key);
export const bundleFullPrice = (b) => b.addons.reduce((s, k) => s + addonPrice(k), 0);
export const bundleSavings = (b) => bundleFullPrice(b) - b.price;

const coveredBy = (bundles) => SITE.bundles.filter((b) => bundles.includes(b.key)).flatMap((b) => b.addons);

/** Total for a selection {addons: string[], bundles: string[], vehicleSize: 'standard'|'suv'} */
export const selectionTotal = ({ addons, bundles, vehicleSize, basePrice = SITE.priceNumeric }) => {
  const covered = coveredBy(bundles);
  const extras = addons.filter((k) => !covered.includes(k));
  const bundlePrice = bundles.reduce((s, k) => s + (getBundle(k)?.price || 0), 0);
  const addonsPrice = extras.reduce((s, k) => s + addonPrice(k), 0);
  const subtotal = basePrice + bundlePrice + addonsPrice;
  const surchargePct = vehicleSize === "suv" ? SITE.suvSurchargePct : 0;
  const surcharge = Math.round((subtotal * surchargePct) / 100);
  return { bundlePrice, addonsPrice, surchargePct, surcharge, subtotal, total: subtotal + surcharge, extras };
};

/** Toggle an addon; auto-upgrade to a bundle when all its items are chosen, split a bundle when removing one item. */
export const toggleAddonSelection = ({ addons, bundles }, key) => {
  const owner = SITE.bundles.find((b) => bundles.includes(b.key) && b.addons.includes(key));
  if (owner) {
    const rest = owner.addons.filter((a) => a !== key && !addons.includes(a));
    return { bundles: bundles.filter((b) => b !== owner.key), addons: [...addons.filter((a) => a !== key), ...rest] };
  }
  const next = addons.includes(key) ? addons.filter((a) => a !== key) : [...addons, key];
  const upgrade = SITE.bundles.find((b) => !bundles.includes(b.key) && b.addons.every((a) => next.includes(a)));
  if (upgrade) {
    return { bundles: [...bundles, upgrade.key], addons: next.filter((a) => !upgrade.addons.includes(a)), upgraded: upgrade };
  }
  return { bundles, addons: next };
};

export const toggleBundleSelection = ({ addons, bundles }, key) => {
  const b = getBundle(key);
  return bundles.includes(key)
    ? { bundles: bundles.filter((k) => k !== key), addons }
    : { bundles: [...bundles, key], addons: addons.filter((a) => !b.addons.includes(a)) };
};

// ---- Cross-section preselect (Pricing -> Reservation) ----
const EVT = "carspa:preselect";
export const preselect = (detail) => {
  window.dispatchEvent(new CustomEvent(EVT, { detail }));
  document.getElementById("reservation")?.scrollIntoView({ behavior: "smooth", block: "start" });
};
export const onPreselect = (handler) => {
  const fn = (e) => handler(e.detail);
  window.addEventListener(EVT, fn);
  return () => window.removeEventListener(EVT, fn);
};
